import _ from 'lodash'
import React from 'react'

import { Box, Link, Paper, Skeleton, Stack, Typography } from '@mui/material'

import EventCard from '../molecules/EventCard'
import Button from '../atoms/Button'
import ChairTitle from '../atoms/ChairTitle'
import CardLeftRight from '../molecules/CardLeftRight'
import TitleSubtitle from '../molecules/TitleSubtitle'
import OurMissions from '../molecules/OurMissions'
import Figures from '../molecules/Figures'
import Zone from '../organisms/Zone'

import strips from '../../media/strips.svg'
import cycle from '../../media/cycle.svg'
import BodyCard from '../atoms/BodyCard'
import useEvents from '../../hooks/useEvents'
import useFigures from '../../hooks/useFigures'
import { APP_BASE_URL, CATEGORIES, DIARY_URL } from '../../constants'
import useCollecterie from '../../hooks/useCollecterie'

const Home = () => {
	const pageNumber = 1
	const numberPerPage = 8
	//TODO: nouveelle categorie
	const { isLoading, events: futureEvents } = useEvents('future', pageNumber, numberPerPage)
	const { figures } = useFigures(CATEGORIES.FIGURES.COLLECTERIE.id)
	const { collecteries } = useCollecterie()

	return (
		<>
			<Zone color="black">
				<Typography
					variant="h3"
					color="secondary"
					sx={(theme) => ({
						fontSize: 16,
						fontWeight: 900,
						[theme.breakpoints.down('md')]: {
							fontSize: 12,
							mb: 1,
						},
					})}
				>
					Agenda
				</Typography>
				<Typography
					variant="h4"
					color="white"
					sx={(theme) => ({
						fontSize: 32,
						fontWeight: 700,
						[theme.breakpoints.down('md')]: {
							fontSize: 24,
							mb: 1,
						},
					})}
				>
					Participez à nos <br /> prochains événements
				</Typography>
				<Box
					sx={{
						oveflowX: 'scroll',
						maxWidth: 1200,
						justifyContent: 'center',
						m: (theme) => theme.spacing(0, 'auto'),
					}}
				>
					<Stack
						sx={(theme) => ({
							m: theme.spacing(4, 'auto', 2),
							overflowX: 'scroll',
						})}
						direction="row"
						justifyContent="flex-start"
						spacing={4}
					>
						{(isLoading && <Skeleton />) ||
							(futureEvents &&
								_.reverse(futureEvents?.list).map(
									({ title, date, hour, description, link, categoryName, image, id }) => (
										<>
											{(link && (
												<Link href={link} underline="none" target="_blank" key={id}>
													<EventCard
														image={image}
														bg="text.greyLight"
														title={date}
														hour={hour}
														subtitle={title}
														body={description}
														eventType={categoryName}
													/>
												</Link>
											)) || (
												<EventCard
													image={image}
													bg="text.greyLight"
													title={date}
													hour={hour}
													subtitle={title}
													body={description}
													eventType={categoryName}
												/>
											)}
										</>
									),
								))}
					</Stack>
				</Box>

				<Button
					label="Retrouver tous les événements"
					bgColor="blue"
					color="white"
					href={`${APP_BASE_URL}${DIARY_URL}`}
				/>
			</Zone>

			<Zone color="ivory">
				<TitleSubtitle title="LA collecterie" subtitle="Qu'est-ce que c'est ?" />

				{collecteries &&
					collecteries.map(({ id, title, description, image, video, srcset }, index) => (
						<CardLeftRight
							src={srcset}
							image={image}
							video={video}
							hasRightTitle={index % 2 === 0}
							key={id}
						>
							<ChairTitle label={title} />
							<BodyCard>
								<Typography
									sx={(theme) => ({
										flexBasis: '47%',
										[theme.breakpoints.down('md')]: {
											flexBasis: '100%',
										},
									})}
									dangerouslySetInnerHTML={{ __html: description }}
								></Typography>
							</BodyCard>
						</CardLeftRight>
					))}
				<OurMissions />
			</Zone>
			<Paper
				sx={(theme) => ({
					bgcolor: 'primary.main',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(16, 14),
					backgroundImage: `url(${strips})`,
					backgroundRepeat: 'round no-repeat',

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
						backgroundRepeat: 'no-repeat',
					},
				})}
			>
				<TitleSubtitle subtitle="Le cycle du réemploi solidaire" />
				<img
					src={cycle}
					alt="Le cycle du réemploi solidaire"
					style={{ width: '100%', maxwidth: 1102 }}
				/>
			</Paper>
			<Paper
				sx={(theme) => ({
					bgcolor: 'text.primary',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(10, 14),

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
					},
				})}
			>
				<TitleSubtitle
					subtitle="La Collecterie en chiffres"
					title="depuis 2012"
					color="white"
					titleColor="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Paper>
		</>
	)
}

export default Home
